export default "__VITE_ASSET__Bls4$3E1__"